module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-认证.8403c.png";